import PermissionsList from '../../permissions/permissions-list.component';
import ProfileRolesList from '../profile-roles-list/profile-roles-list.component';

interface AuthorizationTabProps {
    userId: string;
}

const AuthorizationTab = ({ userId }: AuthorizationTabProps) => {
    return (
        <>
            <ProfileRolesList userId={userId} />
            <PermissionsList
                entityId={userId}
                entityType='users'
            />
        </>
    );
};

export default AuthorizationTab;
